import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function headerCell(theme: Theme): ComponentStyle {
  return {
    componentName: 'headerCell',
    baseStyle: {
      fontWeight: 500,
      color: theme.colors.text,
      fontSize: theme.sizes['-1'],
      background: theme.colors.hype.background75,
      paddingTop: theme.space.s,
      paddingBottom: theme.space.s,

      '&:first-child': {
        paddingLeft: theme.space['s']
      },

      '&:last-child': {
        paddingRight: theme.space['s']
      }
    },
    variants: {
      insideCard: {}
    }
  };
}
